import { StylesIndexInjections } from "common-react";
import { createStyles, makeUiStyles } from "../styles/styles";

export default makeUiStyles(() => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    '&:not(:last-of-type)': {
        marginBottom: 8,
    },
  },
  delimiter: {
    marginRight: 4,
  },
}), { name: 'Address', index: StylesIndexInjections.UI_ATOMS });

